export const previewGameData = {
  "gameData": {
    "playerCount": 42,
    "createdLevels": 3,
    "status": "active",
    "gameName": "Gamably Preview Game",
    "createdItems": 27,
    "createdTeams": 2,
    "orgId": "1725944136600_org",
    "shortDesc": "The Gamably Preview: A Test Game for Exploring Our Features!",
    "ts_created": 1730324415923,
    "access": [
      "points",
      "leaderboards",
      "levels",
      "badges",
      "challenges",
      "secretCodes",
      "currency",
      "marketplace",
      "items",
      "prizepacks",
      "collections",
      "store"
    ],
    "joinCode": "gamably-preview",
    "creatorName": "Testy McTester",
    "color": "#674fa7",
    "enroll_upload": true,
    "path": "previewgame",
    "bg": {
      "url": "https://app.gamably.com/images/themes/2025/fantasy_bg.jpg",
      "type": "image"
    },
    "gameId": "previewgame",
    "creatorId": "aNapmyU75jGnponX7NyizAmjq4uZ",
    "border_header": "none",
    "createdChallenges": 6,
    "createdElementTotal": 86,
    "createdCollections": 6,
    "desc": `<p>This Gamably Preview Game is designed to showcase our features and functionality including:</p>
    <ul>
    <li>Points</li>
    <li>Leaderboards</li>
    <li>Levels</li>
    <li>Badges</li>
    <li>Challenges</li>
    <li>Secret Codes</li>
    <li>Items</li>
    <li>The Item Marketplace</li>    
    <li>Prize Packs</li>
    <li>Collections</li>
    <li>And More!</li>
    </ul>`,
    "icon": "/images/themes/2025/fantasy_icon.jpg",
    "border_icon": "none",
    "sortLeaders": "points",
    "header": "/images/themes/2025/fantasy_head.jpg",
    "createdLeaderboards": 7,
    "createdBadges": 4,
    "enroll_email": true,
    "createdPrizePacks": 3,
    "ts": 1770155494770,
    "type": "full",
    "createdSecretCodes": 30
  }
}

export const previewGameStats = {
  "1772230537889-86781-LNymX-item_earned": 2,
  "1772569770551-86781-LNymX-challenge_declined": 1,
  "1772590997526-86781-LNymX-prizepack_earned": 11,
  "1772230537881-86781-LNymX-item_purchased": 1,
  "currency_earned": 5450,
  "1772572118651-86781-LNymX-challenge_submitted": 1,
  "1772595348386-86781-LNymX-secretCode_earned": 1,
  "1772230537871-86781-LNymX-item_purchased": 2,
  "1772230537885-86781-LNymX-item_earned": 1,
  "1772230537869-86781-LNymX-item_purchased": 1,
  "1772230537869-86781-LNymX-item_earned": 1,
  "1772595348387-86781-LNymX-secretCode_earned": 1,
  "1772572118651-86781-LNymX-challenge_approved": 1,
  "1772230537881-86781-LNymX-item_earned": 1,
  "1772590648474-86781-LNymX-level_earned": 6,
  "ts": 1774663210148,
  "1772230537882-86781-LNymX-item_purchased": 1,
  "1772230537890-86781-LNymX-item_earned": 3,
  "1772230537866-86781-LNymX-item_earned": 7,
  "1772569886040-86781-LNymX-challenge_approved": 1,
  "1772230537888-86781-LNymX-item_earned": 4,
  "1772230537874-86781-LNymX-item_earned": 1,
  "1772569834612-86781-LNymX-challenge_approved": 1,
  "1772595348385-86781-LNymX-secretCode_earned": 1,
  "1772595348384-86781-LNymX-secretCode_earned": 1,
  "1772230537874-86781-LNymX-item_purchased": 1,
  "1772230537875-86781-LNymX-item_earned": 3,
  "1772230537891-86781-LNymX-item_earned": 2,
  "1772230537885-86781-LNymX-item_purchased": 1,
  "1772230537871-86781-LNymX-item_submitted": 1,
  "1772595348383-86781-LNymX-secretCode_earned": 1,
  "1772569886040-86781-LNymX-challenge_submitted": 2,
  "1772569834612-86781-LNymX-challenge_submitted": 1,
  "1772569770551-86781-LNymX-challenge_approved": 2,
  "1772230537882-86781-LNymX-item_earned": 1,
  "1772230537887-86781-LNymX-item_earned": 1,
  "1772569770551-86781-LNymX-challenge_submitted": 3,
  "1772590711756-86781-LNymX-level_earned": 1,
  "1772230537868-86781-LNymX-item_earned": 5,
  "1772230537870-86781-LNymX-item_earned": 4,
  "1772230537871-86781-LNymX-item_earned": 2,
  "points_earned": 1280
}

export const previewGameMessages = {}

export const previewRewardPresets = {}

export const previewUserContent = {
  "currentUser": {
    "displayName": "Testy McTester",
    "email": "preview@gamably.com",
    "metadata": {
      "createdAt": new Date().getTime(),
    },
    "photoURL": "https://gamably.com/images/themes/2025/gamably_icon.png",
    "provider": "preview",
    "uid": "preview-manager"
  },
  "membership": {
    "appId": "preview-manager",
    "email": "preview@gamably.com",
    "membership": 3,
    "ts": new Date().getTime(),
    "ts_expires": 0
  },
  "userProfile": {
    "admin": false,
    "appId": "preview-manager",
    "birthday": 21600000,
    "email": "preview@gamably.com",
    "fName": "Testy",
    "gamesCreated": [],
    "gradient": "linear-gradient(to left, #c1745f, #81b165)",
    "icon": "https://gamably.com/images/themes/2025/gamably_icon.png",
    "lName": "McTester",
    "legalApproved": new Date().getTime(),
    "name": "Testy McTester",
    "purpose": "Business",
    "status": "active",
    "stripeCustomerId": "preview-manager",
    "ts_created": new Date().getTime(),
    "ts_joined": new Date().getTime(),
    "ts": new Date().getTime(),
    "uid": "preview-manager"
  }
}